// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { getOrCreateSocketManager } from '@makemydeal/dr-sales-checkin-ui-utils';
import { processSocketEvent } from '@makemydeal/dr-sales-checkin-store';
import type { SocketEventPayload } from '@makemydeal/dr-shared-bff-types';

// actions
import type { ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { BOOTSTRAP_SUCCESS } from '@makemydeal/dr-shared-store/actionTypes/bootstrapActionTypes';

/**
 * This is responsible to configure socketManager for the given configuration to point to DealxgEvents when the app bootstraps
 */
export const webSocketMiddleware = (store: ReduxStore<any>) => (next: ReduxNext) => async (action: AnyFSA) => {
    // need reducers to execute first so that we can use the state that's updated by INIT_PENCIL_SUCCESS
    const nextResult = next(action);

    switch (action.type) {
        case BOOTSTRAP_SUCCESS: {
            const state = store.getState();
            const wsUrl = state.config?.websockets?.url;
            const dealExchangeId = state.salesCheckin?.activeDeal?.details?.dealId;

            if (dealExchangeId && wsUrl) {
                getOrCreateSocketManager({
                    wsUrl,
                    dealExchangeId,
                    messageCallback: (payload) => store.dispatch(processSocketEvent(payload as SocketEventPayload))
                });
            }

            break;
        }
    }

    return nextResult;
};
